export const animationMixin = {
    methods: {
        expandEnter(el) {
            if(this.isCollapsed){
                el.style.width = '350px'
            } else {
                el.style.height = el.scrollHeight + 'px'
            }
        },
        expandAfterEnter(el) {
            el.style.height = 'auto'
        },
        expandBeforeLeave(el) {
            if(this.isCollapsed) {
                el.style.display = 'none'
                return;
            }
            el.style.height = el.scrollHeight + 'px'
        }
    }
}